<template>
  <div class="profil-container container">
    <div class="presentation-container">
      <img
        v-if="expert.presentation && expert.presentation.mime.includes('image')"
        :src="presentationMediaUrl"
        :alt="
          `picture presentation ${expert.user.firstname} ${expert.user.lastname}`
        "
        loading="lazy"
        class="absolute inset-0 w-full h-full object-cover max-w-none rounded-xl"
      />
      <video
        v-if="expert.presentation && expert.presentation.mime.includes('video')"
        :src="presentationMediaUrl"
        :alt="
          `video presentation ${expert.user.firstname} ${expert.user.lastname}`
        "
        :type="expert.presentation.mime"
        loop
        autoplay
        muted
        show
        controls
        class="absolute inset-0 w-full h-full object-cover max-w-none rounded-xl"
      />
    </div>
    <!-- User -->
    <div class="profil-content">
      <header class="flex w-full flex-row items-center">
        <div class="relative w-full">
          <div v-if="expert.user" class="name">
            {{ expert.user.firstname }} {{ expert.user.lastname }}
          </div>
          <div class="job">{{ expert.jobTitle }}</div>
          <div class="flex flex-row flex-wrap items-center mt-4">
            <!-- Language -->
            <div v-if="expert.city" class="badge mr-3 mb-2">
              <svg
                width="11"
                height="12"
                viewBox="0 0 11 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current text-gray-500 mr-1"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M2.585 7.9983C2.0076 7.42161 1.61422 6.68661 1.45464 5.8863C1.29506 5.08599 1.37645 4.25633 1.68851 3.50228C2.00057 2.74824 2.52928 2.1037 3.20774 1.65021C3.8862 1.19672 4.68393 0.954666 5.5 0.954666C6.31607 0.954666 7.1138 1.19672 7.79226 1.65021C8.47073 2.1037 8.99943 2.74824 9.31149 3.50228C9.62356 4.25633 9.70494 5.08599 9.54536 5.8863C9.38578 6.68661 8.99241 7.42161 8.415 7.9983L5.82542 10.5925C5.78281 10.6354 5.73212 10.6695 5.67627 10.6928C5.62041 10.7161 5.56051 10.728 5.5 10.728C5.4395 10.728 5.37959 10.7161 5.32374 10.6928C5.26788 10.6695 5.21719 10.6354 5.17458 10.5925L2.585 7.9983ZM7.76875 7.35205C8.21741 6.90334 8.52294 6.33167 8.64671 5.70932C8.77048 5.08697 8.70692 4.4419 8.46408 3.85568C8.22124 3.26945 7.81002 2.76839 7.28242 2.41587C6.75482 2.06335 6.13454 1.87519 5.5 1.87519C4.86547 1.87519 4.24518 2.06335 3.71758 2.41587C3.18998 2.76839 2.77876 3.26945 2.53592 3.85568C2.29308 4.4419 2.22952 5.08697 2.35329 5.70932C2.47706 6.33167 2.78259 6.90334 3.23125 7.35205L5.5 9.6208L7.76875 7.35205ZM5.5 6.91663C5.01377 6.91663 4.54746 6.72347 4.20364 6.37966C3.85982 6.03584 3.66667 5.56953 3.66667 5.0833C3.66667 4.59707 3.85982 4.13075 4.20364 3.78693C4.54746 3.44312 5.01377 3.24996 5.5 3.24996C5.98623 3.24996 6.45255 3.44312 6.79636 3.78693C7.14018 4.13075 7.33333 4.59707 7.33333 5.0833C7.33333 5.56953 7.14018 6.03584 6.79636 6.37966C6.45255 6.72347 5.98623 6.91663 5.5 6.91663ZM5.5 5.99996C5.74312 5.99996 5.97627 5.90339 6.14818 5.73148C6.32009 5.55957 6.41667 5.32641 6.41667 5.0833C6.41667 4.84018 6.32009 4.60702 6.14818 4.43512C5.97627 4.26321 5.74312 4.16663 5.5 4.16663C5.25689 4.16663 5.02373 4.26321 4.85182 4.43512C4.67991 4.60702 4.58333 4.84018 4.58333 5.0833C4.58333 5.32641 4.67991 5.55957 4.85182 5.73148C5.02373 5.90339 5.25689 5.99996 5.5 5.99996Z"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <path d="M0 0.5H11V11.5H0V0.5Z" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              {{ expert.city }}
            </div>
            <!-- Language -->
            <div v-if="expert.language" class="badge mr-3 mb-2">
              <svg
                width="11"
                height="12"
                viewBox="0 0 11 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current text-gray-500 mr-1"
              >
                <path
                  d="M0.916626 7.375V2.79167C0.916626 2.2875 1.32913 1.875 1.83329 1.875H9.16663C9.40974 1.875 9.6429 1.97158 9.81481 2.14349C9.98672 2.31539 10.0833 2.54855 10.0833 2.79167V9.66667C10.082 9.75637 10.0545 9.84374 10.004 9.91793C9.95358 9.99212 9.88247 10.0499 9.79952 10.084C9.71656 10.1182 9.6254 10.1273 9.53734 10.1101C9.44928 10.0929 9.36819 10.0503 9.30413 9.9875L7.59913 8.29167H1.83329C1.59018 8.29167 1.35702 8.19509 1.18511 8.02318C1.0132 7.85127 0.916626 7.61811 0.916626 7.375ZM9.16663 2.79167H1.83329V7.375H7.79163C7.91252 7.37672 8.02784 7.42614 8.11246 7.5125L9.16663 8.56208V2.79167Z"
                  fill="#A0AEC0"
                />
              </svg>

              {{ expert.language }}
            </div>
            <!-- Skill -->
            <div v-if="expert.tags && expert.tags[0]" class="badge mr-3 mb-2">
              <svg
                width="11"
                height="12"
                viewBox="0 0 11 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current text-gray-500 mr-1"
              >
                <path
                  d="M5.04169 9.66667V8.71334C4.63545 8.64438 4.24989 8.48502 3.91352 8.24702C3.57716 8.00902 3.29857 7.69848 3.09835 7.33834C2.83347 7.38795 2.56092 7.37886 2.29994 7.3117C2.03895 7.24453 1.79587 7.12093 1.58784 6.94962C1.37981 6.7783 1.2119 6.56343 1.09593 6.32017C0.979971 6.0769 0.918784 5.81116 0.916687 5.54167V3.25001C0.916687 2.74584 1.32919 2.33334 1.83335 2.33334H2.75002C2.75002 1.82917 3.16252 1.41667 3.66669 1.41667H7.33335C7.57647 1.41667 7.80963 1.51325 7.98153 1.68516C8.15344 1.85707 8.25002 2.09022 8.25002 2.33334H9.16669C9.4098 2.33334 9.64296 2.42992 9.81487 2.60182C9.98678 2.77373 10.0834 3.00689 10.0834 3.25001V5.54167C10.0835 5.81206 10.0239 6.07915 9.90877 6.32379C9.79361 6.56844 9.62576 6.78458 9.41725 6.95673C9.20874 7.12888 8.96474 7.25278 8.70272 7.31955C8.4407 7.38631 8.16715 7.3943 7.90169 7.34292C7.70095 7.70221 7.42214 8.01186 7.0858 8.24904C6.74946 8.48622 6.36418 8.64489 5.95835 8.71334V9.66667H7.79169C7.91324 9.66667 8.02982 9.71496 8.11578 9.80091C8.20173 9.88687 8.25002 10.0034 8.25002 10.125C8.25002 10.2466 8.20173 10.3631 8.11578 10.4491C8.02982 10.5351 7.91324 10.5833 7.79169 10.5833H3.20835C3.0868 10.5833 2.97022 10.5351 2.88426 10.4491C2.79831 10.3631 2.75002 10.2466 2.75002 10.125C2.75002 10.0034 2.79831 9.88687 2.88426 9.80091C2.97022 9.71496 3.0868 9.66667 3.20835 9.66667H5.04169ZM8.21335 6.45834H8.25002C8.49313 6.45834 8.72629 6.36176 8.8982 6.18985C9.07011 6.01794 9.16669 5.78479 9.16669 5.54167V3.25001H8.25002V6.00001C8.25002 6.15584 8.23627 6.30709 8.21335 6.45834ZM2.78669 6.45834C2.76178 6.30684 2.74951 6.15354 2.75002 6.00001V3.25001H1.83335V5.54167C1.83325 5.6652 1.85812 5.78747 1.90647 5.90115C1.95481 6.01482 2.02563 6.11755 2.11467 6.20317C2.20371 6.28879 2.30914 6.35552 2.42462 6.39937C2.54011 6.44322 2.66326 6.46328 2.78669 6.45834ZM3.66669 2.33334V6.00001C3.66669 6.48624 3.85984 6.95255 4.20366 7.29637C4.54747 7.64018 5.01379 7.83334 5.50002 7.83334C5.98625 7.83334 6.45257 7.64018 6.79638 7.29637C7.1402 6.95255 7.33335 6.48624 7.33335 6.00001V2.33334H3.66669Z"
                  fill="#A0AEC0"
                />
              </svg>

              {{ expert.tags[0].name }}
            </div>
          </div>
        </div>
      </header>

      <section
        class="max-w-xs mt-10 md:max-w-lg text-base text-black leading-6"
      >
        <div class="test whitespace-pre-wrap">{{ expert.description }}</div>
      </section>

      <!-- medias -->
      <section
        v-if="expert.medias"
        class="flex flex-row flex-wrap mt-10 max-w-xs md:max-w-lg"
      >
        <div
          v-for="media in expert.medias"
          :key="media._id"
          class="media-content"
        >
          <img
            v-if="media.mime.includes('image')"
            :src="getElementSrc(media.url)"
            :alt="media.alternativeText"
            loading="lazy"
            class="absolute inset-0 w-full h-full bg-gray-200 object-cover rounded"
          />
          <video
            v-if="media.mime.includes('video')"
            :src="getElementSrc(media.url)"
            :alt="media.alternativeText"
            :type="media.mime"
            class="absolute inset-0 w-full h-full bg-gray-200 rounded"
          />
        </div>
      </section>

      <!-- tags -->
      <section
        v-if="expert.tags && expert.tags.length"
        class="mt-12 max-w-xs md:max-w-lg"
      >
        <p class="text-lg font-medium text-black tracking-tight leading-none">
          Expertise area
        </p>
        <p class="mt-3 text-sm text-gray-600">
          This is the topics where
          {{ expert && expert.user ? expert.user.firstname : 'he/she' }} has an
          exepertise.
          <br class="hidden md:inline" />
          Politely ask if the topic you want to discuss isn’t in the list.
        </p>
        <div class="flex flex-row flex-wrap mt-6">
          <div
            v-for="tag in expert.tags"
            :key="tag._id"
            class="badge clickable mr-4 mb-3 cursor-pointer"
            @click="onClickTag(tag)"
          >
            {{ tag.name }}
          </div>
        </div>
      </section>

      <!-- Availability -->
      <section
        v-if="expert.averageDuration"
        id="calendar-section"
        class="mt-12 max-w-xs md:max-w-lg"
      >
        <p class="text-lg font-medium text-black tracking-tight leading-none">
          Availability
        </p>
        <p class="mt-3 text-sm text-gray-600">
          This is when
          {{ expert && expert.user ? expert.user.firstname : 'he/she' }} is
          available for {{ expert.averageDuration }} min meetings.
        </p>
        <CalendarAvailability
          :calendar-error="calendarError"
          :availability="availability"
          :selected-slots="selectedSlots"
          :is-loading="$fetchState.pending"
          :timezone="getTimezone"
          class="mt-4"
          @onRefreshData="fetchAvailability"
          @onClickCell="onClickCalendarSlot"
        />
      </section>
    </div>

    <!-- overlay displayed if the calendar is displayed-->
    <div v-if="expert.averageDuration" class="fixed-overlay">
      <div class="container px-0 flex flex-row items-center mx-auto">
        <div class="hidden md:block mr-auto">
          <p v-if="isExpertActive" class="text-base text-black font-medium">
            Connect with
            {{ expert && expert.user ? expert.user.firstname : '' }}
            {{
              expert.tags && expert.tags[0]
                ? `, expert in ${expert.tags && expert.tags[0].name}`
                : ''
            }}
          </p>
          <p v-if="!isExpertActive" class="text-base text-black font-medium">
            {{
              expert && expert.user ? expert.user.firstname : 'This expert'
            }}'s profile isn't verified yet.
          </p>
        </div>
        <!-- Rate -->
        <div class="flex flex-row items-center ml-auto w-full md:w-auto">
          <BookingRatePreview :expert="expert" :selected="selectedSlots" />
          <button
            v-if="!isUserMe && isExpertActive"
            aria-label="Send a request"
            class="button-plain button-md ml-auto md:ml-5"
            @click="onClickSendRequest"
          >
            Send a request
          </button>
          <!-- Edit button -->
          <nuxt-link
            v-if="isUserMe"
            class="button-plain button-md ml-auto md:ml-5"
            :to="{ name: 'me-slug', params: { slug: 'profile' } }"
          >
            Edit my profile
          </nuxt-link>
        </div>
      </div>
    </div>

    <ModalReservation
      :is-open="reservationModalOpen"
      :step="reservationModalStep"
      :slots="selectedSlots"
      :price="computedPrice"
      :user-payment-methods="userPaymentMethods"
      :expert="expert"
      @back="onBackButtonClick"
      @close="onReservationModalClose"
      @onNewCardClicked="reservationModalStep = 'payment'"
      @onSignupSuccess="reservationModalStep = 'confirmation'"
      @onDidSubmitMessage="onSubmitMessage"
      @onDidSubmitPayment="reservationModalStep = 'success'"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { sanitizeUri, scrollTop, calculateFees } from '~/helpers';
import CalendarAvailability from '~/components/calendar/CalendarAvailability';
import BookingRatePreview from '~/components/booking/BookingRatePreview';

export default {
  components: {
    CalendarAvailability,
    BookingRatePreview,
    ModalReservation: () => import('~/components/modal/ModalReservation')
  },

  /**
   * Load the availability of the expert asyncronously to avoid blocking the rendering server side
   */
  async fetch() {
    await this.fetchAvailability();
    this.fetchPaymentMethods();
    this.checkCalendarErrors();
  },

  fetchOnServer: false,

  async asyncData({ $axios, params, error }) {
    try {
      const res = await $axios.get(`expert/${params.username}`);
      return { expert: res?.data };
    } catch (err) {
      error({ statusCode: 404, message: 'User not found' });
    }
  },

  data() {
    return {
      userPaymentMethods: null,
      // modal reservation
      reservationModalStep: null,
      reservationModalOpen: false,
      // state
      calendarError: null,
      selectedSlots: [],
      isLoadingCalendar: true,
      availability: []
    };
  },

  computed: {
    ...mapGetters({
      loggedUser: 'user',
      isAuthenticated: 'isAuthenticated'
    }),

    computedPrice() {
      const baseAmount = this.selectedSlots.length * this.expert.basePrice;
      const price = calculateFees(baseAmount, 'EUR');
      return price;
    },

    presentationMediaType() {
      return this.expert?.presentation?.mime?.includes?.('video')
        ? 'video'
        : 'image';
    },

    /**
     * Return the URL of the video source
     * Either the one we uploaded, either the one fetched
     */
    presentationMediaUrl() {
      const uri = this.expert.presentation?.url;
      return sanitizeUri(uri);
    },

    isUserMe() {
      return (
        this.isAuthenticated && this.loggedUser._id === this.expert?.user?._id
      );
    },

    getTimezone() {
      return this.expert?.schedule?.timezone?.utc?.[0];
    },

    isExpertActive() {
      return (
        !this.expert.basePrice ||
        this.expert?.user?.stripeAccountStatus === 'charges_enabled' ||
        this.expert?.user?.stripeAccountStatus === 'verified' ||
        this.expert?.user?.stripeAccountStatus === 'active'
      );
    }
  },

  methods: {
    onSubmitMessage() {
      if (this.userPaymentMethods?.length) {
        this.reservationModalStep = 'paymentMethods';
        return;
      }
      this.reservationModalStep = 'payment';
    },

    async fetchPaymentMethods() {
      try {
        if (!this.loggedUser) {
          return;
        }
        const { data } = await this.$axios.get('me/payments-methods');
        if (data?.length) {
          this.userPaymentMethods = data;
        }
      } catch (error) {
        console.log('error while loading cards', error);
      }
    },

    onBackButtonClick() {
      if (
        this.userPaymentMethods?.length &&
        this.reservationModalStep === 'payment'
      ) {
        this.reservationModalStep = 'paymentMethods';
        return;
      }
      if (this.reservationModalStep === 'payment') {
        this.reservationModalStep = 'confirmation';
      }
      if (this.reservationModalStep === 'paymentMethods') {
        this.reservationModalStep = 'confirmation';
      }
    },

    onReservationModalClose() {
      if (this.reservationModalStep === 'success') {
        this.$router.push({ name: 'bookings' });
        return;
      }
      this.reservationModalOpen = false;
    },

    /**
     * Fetch the availability
     */
    async fetchAvailability() {
      // load the availability async
      this.calendarError = null;
      if (this.isLoadingCalendar) {
        this.isLoadingCalendar = true;
      }

      this.checkCalendarErrors();

      try {
        const { data } = await this.$axios.get(
          `expert/${this.$route.params.username}/availability`
        );
        this.availability = data;
        this.$nextTick(() => {
          this.isLoadingCalendar = false;
        });
      } catch (err) {
        this.isLoadingCalendar = false;
        this.calendarError = 'Error while loading calendar, click to retry';
      }
    },

    /**
     * Check if after 10s the calendar is still loading and no error has been shown
     */
    checkCalendarErrors() {
      setTimeout(() => {
        if (this.isLoadingCalendar && !this.calendarError) {
          this.$nextTick(() => {
            this.isLoadingCalendar = false;
            this.calendarError = 'Error while loading calendar, click to retry';
          });
        }
      }, 10000);
    },

    /**
     * After the user clicks on send request
     */
    onClickSendRequest() {
      // If none selected, scroll to bloc
      if (!this.selectedSlots?.length) {
        const calendar = document.getElementById('calendar-section');
        if (!calendar) {
          return;
        }
        scrollTop({
          element: window,
          scrollTo: calendar.offsetTop - 100
        });
        return;
      }

      // Step signup
      if (!this.loggedUser) {
        this.reservationModalOpen = true;
        this.reservationModalStep = 'signup';
        return;
      }

      // Check if user is logged-in and displau signup
      this.reservationModalOpen = true;
      this.reservationModalStep = 'confirmation';
    },

    /**
     * Handle the click on a cell in the calendar
     */
    onClickCalendarSlot(slot) {
      // remove if already selected
      const index = this.selectedSlots.findIndex(
        (s) => s.startsAt === slot.startsAt
      );
      if (index > -1) {
        this.selectedSlots.splice(index, 1);
        return;
      }
      // Or add it to the list
      this.selectedSlots.push(slot);
    },

    /**
     * Returns the element source
     */
    getElementSrc(mediaUrl) {
      return sanitizeUri(mediaUrl);
    },

    onClickTag(tag) {}
  },

  head() {
    const name = `${this.expert?.user?.firstname} ${this.expert?.user?.lastname}`;
    const meta = [
      {
        hid: 'description',
        name: 'description',
        content:
          'Answer your questions with 1:1 talks with experts. With GoodMinds.club you can connect and talk with experts and get help on the topics you need. Get answers when you’re stuck.'
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content:
          'Answer your questions with 1:1 talks with experts. With GoodMinds.club you can connect and talk with experts and get help on the topics you need. Get answers when you’re stuck.'
      },
      {
        hid: 'og:title',
        name: 'og:title',
        content: `${name} | GoodMinds.club`
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: `${name} | GoodMinds.club`
      }
    ];

    if (this.expert?.metaImageUrl) {
      meta.push({
        hid: 'og:image',
        name: 'og:image',
        content: this.expert?.metaImageUrl
      });
      meta.push({
        hid: 'twitter:image',
        name: 'twitter:image',
        content: this.expert?.metaImageUrl
      });
    }

    return {
      title: `${name} |  GoodMinds.club`,
      meta
    };
  }
};
</script>

<style lang="postcss" scoped>
/**
 * Rest of style
 */
.profil-container {
  @apply flex flex-col justify-center mb-32;
  padding: 30px 30px 0;

  @screen sm {
    padding: 0 auto;
  }

  @screen md {
    @apply flex-row pt-20;
  }
}

.presentation-container {
  @apply relative w-full h-64 bg-gray-200 overflow-hidden rounded-xl shadow-2xl bg-cover bg-no-repeat;

  @screen md {
    width: 375px;
    height: 667px;
    max-width: 375px;
    max-height: 667px;
  }
}

.profil-content {
  @apply mt-12;

  @screen md {
    @apply mt-0 ml-20;
  }
  .name {
    @apply font-semibold leading-none;
    font-size: 1.875rem;
  }
  .job {
    @apply text-base text-gray-600 mt-1;
  }
}

.media-content {
  @apply transition transform scale-100 duration-150 ease-in-out w-24 h-24 overflow-hidden mb-3 mr-4 rounded shadow-xl cursor-pointer flex-shrink-0;
  &:hover {
    @apply shadow-md;
  }
  &:active {
    @apply transform scale-95;
  }
}

.fixed-overlay {
  @apply fixed bottom-0 inset-x-0 z-30 py-4;
  padding-left: 30px;
  padding-right: 30px;
  background-color: rgba(249, 249, 249, 0.6);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);

  @screen md {
    @apply p-5;
  }
}

.badge {
  @apply flex flex-row bg-gray-200 rounded text-gray-500 text-xs font-medium leading-none whitespace-no-wrap;
  padding: 6px 8px;

  &.clickable {
    @apply transition-colors duration-100 ease-in;
    &:hover {
      @apply bg-gray-300 text-gray-600;
    }
  }
}
</style>
